import React from 'react';
// ui
import { Typography } from 'rmwc/Typography';
import { Button } from 'rmwc/Button';
import {
    Card,
    CardPrimaryAction,
    CardMedia,
    CardActions
} from 'rmwc/Card';

const ContentCard = ({ onClick, children, img, title, buttonLabel='Open' }) => {
    return (
        <Card style={{ width: '19rem', margin:10, justifyContent: 'space-between' }}>
            <CardPrimaryAction onClick={onClick}>
                <CardMedia
                    sixteenByNine
                    style={{
                        backgroundImage: `url(../${img})`
                    }}
                />
                <div style={{ padding: '0 1rem 1rem 1rem' }}>
                    <Typography use="headline6" tag="h2">
                        {title}
                    </Typography>

                    <Typography use="body1" tag="div" theme="text-secondary-on-background">
                        {children}
                    </Typography>

                </div>
            </CardPrimaryAction>
            <CardActions style={{ justifyContent: 'flex-end' }}>
                <Button raised theme={'secondary-bg'} onClick={onClick}>
                    {buttonLabel}
                </Button>
            </CardActions>
        </Card>
    )
};

export default ContentCard;


// WEBPACK FOOTER //
// ./src/app/components/ContentCard.js